import axios from "axios";

import { errorHandler, commonRes } from "./ErrorHandler";

export const getAuditByDate = async (date) => {
  let access_token = localStorage.getItem("access_token");
  if (access_token.length > 0) {
    let backend_url = process.env.REACT_APP_BACKEND_URL,
      manufacturer = localStorage.getItem("manufacturer");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await axios.get(
        `${backend_url}/api/auditReview/getAudits?manufacturer=${manufacturer}&date=${date}`,
        { headers: headers }
      );
      return commonRes(false, { ...res.data });
    } catch (err) {
      return errorHandler(err, getAuditByDate);
    }
  } else {
    return commonRes(
      true,
      "You're not logged in. please log in!",
      "NO_ACCESS_TOKEN"
    );
  }
};

export const sendBackToCV = (body) => {
  let access_token = localStorage.getItem("access_token");
  if (access_token.length > 0) {
    let backend_url = process.env.REACT_APP_BACKEND_URL;
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    return axios
      .post(
        `${backend_url}/api/auditReview/update`,
        { ...body },
        {
          headers: headers,
        }
      )
      .then((res) => res.data);
  } else {
    return commonRes(
      true,
      "You're not logged in. please log in!",
      "NO_ACCESS_TOKEN"
    );
  }
};
